module.exports = __webpack_public_path__ + "fonts/sam-icons.d322173.woff2";